<template>
    <div class="p-col-12 p-md-6 p-lg-2 text-center">
        <router-link  :to="{ name: link }" v-if="link">
            <div class="card summary">
                <div v-if="icon">
                    <i :class="icon" class="p-mr-2" :style="{'font-size': iconFontSize+'px'}" />
                </div>
                <div class="p-mt-2">
                    <span :style="{'font-size': titleFontSize+'px'}" class="title">{{$t(title)}}</span>
                </div>
            </div>
        </router-link>
        <div class="card summary" v-else>
            <div v-if="icon">
                <i :class="icon" class="p-mr-2" :style="{'font-size': iconFontSize+'px'}" />
            </div>
            <div class="p-mt-2">
                <span :style="{'font-size': titleFontSize+'px'}" class="title">{{$t(title)}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SquareCard",
        props: {
            title: {type: String, default: ''},
            icon: {type: String, default: ''},
            link: {type: String, default: null},
            iconFontSize: {type: String, default: '35'},
            titleFontSize: {type: String, default: '20'},
        }
    }
</script>

<style scoped>

</style>